import React from 'react';

const CloseSubPopup = (props) => {

  const {
    closeHandler,
    additionalClasses = []
  } = props;

  return (
    <div
      className={`popup-info__close_sub-popup ${additionalClasses.join(' ')}`}
      onClick={closeHandler}
    >&times;</div>
  );
};

export default CloseSubPopup;